import React, { Component } from "react";
import Service from "../../../Service/Service";
import PulverizingLogo from "../../../Graphics/PulverizingLogo";
import plant from "../../../../../media/reduced-images/plant.jpg";

class Pulverizing extends Component {
  render() {
    return (
      <Service
        logo={<PulverizingLogo />}
        image={plant}
        title="Pulverizing"
        description="We can grind and pulverize all forms of raw materials; 
        this includes plastic pellets, slab/sheet plastics, rejected parts, 
        and natural materials.  We can produce final product sizes from ½” to 
        270 mesh.  We accommodate all types of final packaging.  We will fill 
        50 lb. bags or cartons, fiber drums, or supersacks."
      />
    );
  }
}

export default Pulverizing;
